export const filterSystemAndCurrentUser = function (users, currentProfile) {
  if (!users || !currentProfile) return [];

  return users.filter(
    user =>
      !user.isSystemUser &&
      !(
        user.externalId === currentProfile.externalId &&
        user.externalScope === currentProfile.externalScope
      )
  );
};

export const matchingUsers = function (userA, userB) {
  return userA.externalId === userB.externalId && userA.externalScope === userB.externalScope;
};
